<template>
  <card>
    <template slot="header">
      <h4 class="mb-0">Quick Stats</h4>
    </template>
    
    <div class="stats-section">
      <!-- Total Leads -->
      <div class="stat-item">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <span class="text-sm text-muted">Total Leads</span>
            <div class="h3 font-weight-bold mb-0">{{ totalLeads }}</div>
          </div>
          <div class="icon icon-shape bg-gradient-primary text-white rounded-circle shadow">
            <i class="ni ni-single-02"></i>
          </div>
        </div>
      </div>

      <hr class="my-3">

      <!-- Recent Activity -->
      <div class="stat-item">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <span class="text-sm text-muted">Recent Leads (30 days)</span>
            <div class="h3 font-weight-bold mb-0">{{ recentLeads }}</div>
          </div>
          <div class="icon icon-shape bg-gradient-success text-white rounded-circle shadow">
            <i class="ni ni-chart-bar-32"></i>
          </div>
        </div>
      </div>

      <hr class="my-3">

      <!-- Active Events -->
      <div class="stat-item">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <span class="text-sm text-muted">Active Events</span>
            <div class="h3 font-weight-bold mb-0">{{ activeEvents }}</div>
          </div>
          <div class="icon icon-shape bg-gradient-warning text-white rounded-circle shadow">
            <i class="ni ni-calendar-grid-58"></i>
          </div>
        </div>
      </div>

      <hr class="my-3">

      <!-- HubSpot Status -->
      <div class="stat-item">
        <div>
          <span class="text-sm text-muted">HubSpot Integration</span>
          <div class="mt-1">
            <span v-if="hubspotConnected" class="badge badge-success">
              <i class="fas fa-check mr-1"></i>Connected
            </span>
            <span v-else class="badge badge-secondary">
              <i class="fas fa-times mr-1"></i>Not Connected
            </span>
          </div>
        </div>
      </div>

    </div>
  </card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    companyId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      stats: {
        totalLeads: 0,
        recentLeads: 0,
        activeEvents: 0,
        hubspotConnected: false
      }
    };
  },
  computed: {
    ...mapGetters("companies/", {
      company: "getSingleCompanyById",
      getCompanyLeadsByCompanyId: "getCompanyLeadsByCompanyId",
      getCompanyLeadsTotalByCompanyId: "getCompanyLeadsTotalByCompanyId"
    }),
    companyData() {
      return this.company(this.companyId);
    },
    totalLeads() {
      return this.companyData.leads_count || 0;
    },
    recentLeads() {
      return this.stats.recentLeads;
    },
    activeEvents() {
      return this.stats.activeEvents;
    },
    hubspotConnected() {
      return !!(this.companyData.hubspot_object_id && this.companyData.hubspot_owner_id);
    }
  },
  methods: {
    async loadCompanyStats() {
      try {
        this.loading = true;
        
        // Load recent leads (last 30 days)
        const recentLeadsResponse = await this.$store.dispatch("companies/getCompanyRecentLeads", {
          companyId: this.companyId,
          days: 30
        });
        this.stats.recentLeads = recentLeadsResponse.count || 0;

        // Load active events count
        const activeEventsResponse = await this.$store.dispatch("companies/getCompanyActiveEvents", this.companyId);
        this.stats.activeEvents = activeEventsResponse.count || 0;

      } catch (error) {
        console.error('Failed to load company stats:', error);
        // Set defaults on error
        this.stats.recentLeads = 0;
        this.stats.activeEvents = 0;
      } finally {
        this.loading = false;
      }
    }
  },
  async created() {
    await this.loadCompanyStats();
  }
};
</script>

<style scoped>
.stats-section {
  padding: 0.5rem 0;
}

.stat-item {
  margin-bottom: 0.5rem;
}

.icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-group-vertical .btn {
  text-align: left;
  justify-content: flex-start;
}

.badge {
  font-size: 0.75rem;
}
</style>